import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import ContentItem6 from 'presentations/views/components/molecules/ServiceContentItem6';
import { useMemo } from 'react';
import styled from '@emotion/styled';
import { spacing } from 'presentations/views/styles';

interface Props {
  variant: 'slide' | 'list';
  className?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const items = useMemo(() => {
    const data = [];
    for (const i of [0, 1, 2, 3, 4, 5]) {
      if (i === 1) {
        data.push({
          title: t(`itemTitle.${i}`),
          description: t(`itemDescription.${i}`),
          imageUrl: `pages/top/202206/slide/3-${i + 1}.mp4`,
          isVideo: true,
        });
      } else {
        data.push({
          title: t(`itemTitle.${i}`),
          description: t(`itemDescription.${i}`),
          imageUrl: `pages/top/202206/slide/3-${i + 1}.png`,
          isVideo: false,
        });
      }
    }
    return data;
  }, []);
  if (props && props.variant === 'list') {
    return (
      <List className={props.className}>
        {items.map((item, i) => (
          <ListItem>
            <ContentItem6
              items={[item]}
              title={item.title}
              description={item.description}
              imageWidth={858}
              imageHeight={620}
            />
          </ListItem>
        ))}
      </List>
    );
  }
  return (
    <ContentItem6
      items={items}
      title={t('title')}
      subTitle={t('sub title')}
      description={t('description')}
      imageWidth={858}
      imageHeight={620}
    />
  );
}

const List = styled.div``;
const ListItem = styled.div`
  margin-bottom: ${spacing(48)};
  :last-of-type {
    margin-bottom: 0;
  }
`;
